import React from 'react';
import { Link } from 'react-router-dom';
import { Github, Twitter, Linkedin } from 'lucide-react';

const UniversalFooter: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="relative z-10 w-full bg-[#0F172A] border-t border-white/10 mt-auto">
            <div className="container mx-auto px-4 py-8">
                <div className="flex flex-col md:flex-row justify-between items-center gap-4">

                    {/* Brand & Copyright */}
                    <div className="text-center md:text-left">
                        <div className="flex items-center justify-center md:justify-start gap-2 mb-2">
                            <img
                                src="/logo.png"
                                alt="CareVault Logo"
                                className="h-8 w-auto object-contain"
                            />
                            <span className="text-lg font-bold text-white">
                                Care<span className="text-[#D64463]">Vault</span>
                            </span>
                        </div>
                        <p className="text-sm text-white/60">
                            © {currentYear} CareVault. Secure Personal Health Records.
                        </p>
                    </div>

                    {/* Links */}
                    <div className="flex gap-6 text-sm font-medium text-white/80">
                        <Link to="/privacy" className="hover:text-[#D64463] transition-colors">Privacy Policy</Link>
                        <Link to="/terms" className="hover:text-[#D64463] transition-colors">Terms of Service</Link>
                        <Link to="/contact" className="hover:text-[#D64463] transition-colors">Contact Support</Link>
                    </div>

                    {/* Socials */}
                    <div className="flex gap-4">
                        <a href="https://twitter.com/healexiafrica" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/10 hover:bg-[#D64463] hover:text-white transition-all text-white/80">
                            <Twitter size={18} />
                        </a>
                        <a href="https://github.com/healexiafrica" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/10 hover:bg-[#D64463] hover:text-white transition-all text-white/80">
                            <Github size={18} />
                        </a>
                        <a href="https://linkedin.com/company/healexiafrica" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/10 hover:bg-[#D64463] hover:text-white transition-all text-white/80">
                            <Linkedin size={18} />
                        </a>
                    </div>
                </div>


            </div>
        </footer>
    );
};

export default UniversalFooter;
